module.exports = "<div id=\"gallery\">\r\n  Gallery\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/content/gallery/gallery.component.html
// module id = ./src/app/components/content/gallery/gallery.component.html
// module chunks = main